import { index, jsonb, pgTable, text, timestamp, uniqueIndex, uuid } from "drizzle-orm/pg-core";
import { sql } from "drizzle-orm";
import { organisations } from "./organisations";
export var IntegrationProvider;
(function (IntegrationProvider) {
    IntegrationProvider["NOTION"] = "notion";
    IntegrationProvider["SLACK"] = "slack";
    IntegrationProvider["POSTGRES"] = "postgres";
    IntegrationProvider["GCAL"] = "gcal";
    IntegrationProvider["MIXPANEL"] = "mixpanel";
})(IntegrationProvider || (IntegrationProvider = {}));
export const organisationIntegrations = pgTable("organisation_integrations", {
    id: uuid("id").primaryKey().defaultRandom(),
    companyId: uuid("company_id")
        .notNull()
        .references(() => organisations.id, { onDelete: "cascade" }),
    provider: text("provider").notNull().$type(),
    status: text("status").notNull().$type().default("pending"),
    teamId: text("team_id"),
    teamName: text("team_name"),
    installedBy: text("installed_by"),
    installedAt: timestamp("installed_at", { withTimezone: true }),
    revokedAt: timestamp("revoked_at", { withTimezone: true }),
    workspaceId: text("workspace_id"),
    workspaceName: text("workspace_name"),
    botUserId: text("bot_user_id"),
    scopes: jsonb("scopes").notNull().$type().default([]),
    tokenCiphertext: text("token_ciphertext"),
    tokenIv: text("token_iv"),
    tokenAuthTag: text("token_auth_tag"),
    refreshTokenCiphertext: text("refresh_token_ciphertext"),
    refreshTokenIv: text("refresh_token_iv"),
    refreshTokenAuthTag: text("refresh_token_auth_tag"),
    tokenKeyVersion: text("token_key_version").default("v1"),
    lastSyncCursor: text("last_sync_cursor"),
    lastSyncStartedAt: timestamp("last_sync_started_at", { withTimezone: true }),
    lastSyncFinishedAt: timestamp("last_sync_finished_at", { withTimezone: true }),
    lastSuccessfulSyncAt: timestamp("last_successful_sync_at", { withTimezone: true }),
    lastSyncError: text("last_sync_error"),
    // Postgres integration fields
    connectionUrlCiphertext: text("connection_url_ciphertext"),
    connectionUrlIv: text("connection_url_iv"),
    connectionUrlAuthTag: text("connection_url_auth_tag"),
    caCertCiphertext: text("ca_cert_ciphertext"),
    caCertIv: text("ca_cert_iv"),
    caCertAuthTag: text("ca_cert_auth_tag"),
    caCertExpiresAt: timestamp("ca_cert_expires_at", { withTimezone: true }),
    caCertExpiryWarningSentAt: timestamp("ca_cert_expiry_warning_sent_at", { withTimezone: true }),
    clientCertCiphertext: text("client_cert_ciphertext"),
    clientCertIv: text("client_cert_iv"),
    clientCertAuthTag: text("client_cert_auth_tag"),
    clientCertExpiresAt: timestamp("client_cert_expires_at", { withTimezone: true }),
    clientCertExpiryWarningSentAt: timestamp("client_cert_expiry_warning_sent_at", {
        withTimezone: true,
    }),
    clientKeyCiphertext: text("client_key_ciphertext"),
    clientKeyIv: text("client_key_iv"),
    clientKeyAuthTag: text("client_key_auth_tag"),
    metadata: jsonb("metadata").$type().default({}),
    createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
    updatedAt: timestamp("updated_at", { withTimezone: true })
        .notNull()
        .defaultNow()
        .$onUpdate(() => new Date()),
}, table => ({
    // Unique per company+provider for non-gcal providers only; gcal allows multiple accounts per org
    uniqueCompanyProviderNonGcal: uniqueIndex("organisation_integrations_company_provider_non_gcal")
        .on(table.companyId, table.provider)
        .where(sql `${table.provider} != 'gcal'`),
    statusIdx: index("organisation_integrations_status_company").on(table.companyId, table.status),
}));
export const notionPageSyncStates = pgTable("notion_page_sync_states", {
    id: uuid("id").primaryKey().defaultRandom(),
    companyId: uuid("company_id")
        .notNull()
        .references(() => organisations.id, { onDelete: "cascade" }),
    integrationId: uuid("integration_id")
        .notNull()
        .references(() => organisationIntegrations.id, { onDelete: "cascade" }),
    pageId: text("page_id").notNull(),
    pageTitle: text("page_title"),
    pageUrl: text("page_url"),
    contentHash: text("content_hash").notNull(),
    lastEditedTime: timestamp("last_edited_time", { withTimezone: true }),
    metadata: jsonb("metadata").notNull().$type().default({}),
    createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
    updatedAt: timestamp("updated_at", { withTimezone: true })
        .notNull()
        .defaultNow()
        .$onUpdate(() => new Date()),
}, table => ({
    uniquePagePerIntegration: uniqueIndex("notion_page_sync_states_unique").on(table.integrationId, table.pageId),
    companyPageIdx: index("notion_page_sync_states_company_page").on(table.companyId, table.pageId),
}));
